import { render, staticRenderFns } from "./RenewalStatus.vue?vue&type=template&id=38f88d03&scoped=true"
import script from "./RenewalStatus.vue?vue&type=script&lang=js"
export * from "./RenewalStatus.vue?vue&type=script&lang=js"
import style0 from "./RenewalStatus.vue?vue&type=style&index=0&id=38f88d03&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f88d03",
  null
  
)

export default component.exports